/* =========================================================
   OOJU カスタム（2026-08-07）
   ① サイズ注釈  ④⑤ 説明文の整理  ⑥ サイズ表  ⑦ 素材  ⑧ 一覧スウォッチ
   ========================================================= */
(function () {
  'use strict';

  /* 「モデル情報を残したい」場合は下を true にするだけで元に戻ります */
  var OOJU_KEEP_MODEL_LINE = false;

  /* ------------------------------------------------------
     共通ユーティリティ
     ------------------------------------------------------ */
  function txt(el) {
    return (el.textContent || '').replace(/ㅤ| /g, ' ').trim();
  }

  /* ラベルの「表示上の値」だけを取り出す
     （スクリーンリーダー用の隠しテキストやカラーチップを除外） */
  function labelValue(lb) {
    var c = lb.cloneNode(true);
    c.querySelectorAll('.visually-hidden, .label-unavailable, .ooju-color-label__chip').forEach(function (n) {
      n.remove();
    });
    return txt(c);
  }

  /* ------------------------------------------------------
     ① サイズ注釈（適応身長）
     サイズを選択するとShopifyがバリエーション選択部分を
     再描画するため、消えたら自動で復元する
     ------------------------------------------------------ */
  var OOJU_SIZE_MAP = [];

  function findSizeField() {
    var found = null;
    document.querySelectorAll('.product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend, label');
      if (lg && /^(size|サイズ)/i.test(txt(lg))) found = fs;
    });
    return found;
  }

  function renderSizeNote() {
    if (!OOJU_SIZE_MAP.length) return;
    var sizeField = findSizeField();
    if (!sizeField) return;
    if (sizeField.querySelector('.ooju-size-note')) return; /* 既に表示済み */

    /* 実際に販売しているサイズだけに絞り込む
       （サイズ表には4列あるが1〜3しか展開しない商品があるため） */
    var offered = [];
    sizeField.querySelectorAll('label').forEach(function (lb) {
      var v = labelValue(lb);
      if (v) offered.push(v);
    });
    var list = OOJU_SIZE_MAP;
    if (offered.length) {
      list = OOJU_SIZE_MAP.filter(function (s) {
        return offered.indexOf(s.size) !== -1;
      });
    }
    if (!list.length) return;

    var note = document.createElement('div');
    note.className = 'ooju-size-note';
    note.innerHTML =
      '<span class="ooju-size-note__title">サイズの目安（適応身長）</span>' +
      '<ul class="ooju-size-note__list">' +
      list
        .map(function (s) {
          return (
            '<li><span class="ooju-size-note__size">' +
            s.size +
            '</span><span>身長 ' +
            s.height +
            ' cm</span></li>'
          );
        })
        .join('') +
      '</ul>' +
      '<a class="ooju-size-note__link" href="#ooju-size-table">詳しいサイズ表を見る →</a>';
    sizeField.appendChild(note);

    /* 各サイズボタンにも身長をツールチップ表示 */
    sizeField.querySelectorAll('label').forEach(function (lb) {
      var v = labelValue(lb);
      var hit = list.filter(function (s) {
        return s.size === v;
      })[0];
      if (hit) lb.setAttribute('title', '適応身長 ' + hit.height + ' cm');
    });
  }

  /* ------------------------------------------------------
     ⑧ 一覧ページ：カラースウォッチでカード画像を切り替え
     ------------------------------------------------------ */
  function initCardSwatches(scope) {
    (scope || document).querySelectorAll('[data-ooju-swatches]').forEach(function (wrap) {
      if (wrap.dataset.oojuReady) return;
      wrap.dataset.oojuReady = '1';

      var card = wrap.closest('.card-wrapper');
      if (!card) return;
      var img = card.querySelector('.card__media img, .card__inner img');
      var link = card.querySelector('.card__heading a');
      if (!img) return;

      wrap.querySelectorAll('[data-ooju-swatch]').forEach(function (btn) {
        var apply = function () {
          if (btn.dataset.src) img.setAttribute('src', btn.dataset.src);
          if (btn.dataset.srcset) img.setAttribute('srcset', btn.dataset.srcset);
          if (link && btn.dataset.url) link.setAttribute('href', btn.dataset.url);
          wrap.querySelectorAll('[data-ooju-swatch]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
        };
        btn.addEventListener('mouseenter', apply);
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          apply();
        });
      });
    });
  }


  /* ------------------------------------------------------
     在庫「残りわずか」表示（商品ページ）
     選択中のバリエーションの在庫がしきい値以下なら表示する
     ------------------------------------------------------ */
  function initLowStock() {
    var holder = document.querySelector('[data-ooju-stock]');
    if (!holder || !document.querySelector('[data-ooju-low-note]')) return;

    var data;
    try {
      data = JSON.parse(holder.textContent);
    } catch (e) {
      return;
    }
    var threshold = data.threshold || 10;

    function currentVariantId() {
      var m = location.search.match(/[?&]variant=(\d+)/);
      if (m) return m[1];
      var input = document.querySelector('input[name="id"], select[name="id"]');
      return input ? String(input.value) : null;
    }

    /* バリエーションを切り替えるとShopifyが価格まわりを作り直し、
       「残りわずか」も新しい要素に差し替わるため、毎回取り直す（2026-10-01） */
    function update() {
      var note = document.querySelector('[data-ooju-low-note]');
      if (!note) return;
      var id = currentVariantId();
      var qty = id ? data.variants[id] : undefined;
      if (typeof qty === 'number' && qty > 0 && qty <= threshold) {
        var text = note.querySelector('[data-ooju-low-text]');
        if (text && text.textContent !== '残りわずか') text.textContent = '残りわずか';
        note.removeAttribute('hidden');
      } else {
        note.setAttribute('hidden', '');
      }
    }

    update();
    /* 差し替えが終わった合図（テーマ標準のpubsub）で更新し直す */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(update, 0);
      });
    }
    document.addEventListener('change', function () {
      setTimeout(update, 60);
    }, true);
    window.addEventListener('popstate', update);
    var last = location.search;
    setInterval(function () {
      if (location.search !== last) {
        last = location.search;
        update();
      }
    }, 400);
  }

  /* ------------------------------------------------------
     商品詳細ページの処理
     ------------------------------------------------------ */
  function initProductPage() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.oojuReady) return;
    desc.dataset.oojuReady = '1';

    /* --- 旧テーマの残骸（script/style）を除去 --- */
    desc.querySelectorAll('script, style, meta').forEach(function (n) {
      n.remove();
    });

    /* --- 中身のない空要素（全角スペース等のみ）を除去 --- */
    function pruneEmpty() {
      desc.querySelectorAll('p, div, span').forEach(function (n) {
        if (n.classList.contains('ooju-spec') || n.closest('.ooju-spec')) return;
        if (n.querySelector('img, table, iframe, video, button')) return;
        var t = (n.textContent || '').replace(/[\sㅤ 　]/g, '');
        if (t === '') n.remove();
      });
    }
    pruneEmpty();

    /* --- ⑤ 不要な行を非表示 --- */
    var material = '';
    desc.querySelectorAll('p, div').forEach(function (p) {
      if (p.querySelector('table, img')) return;
      var t = txt(p);
      if (!t) return;

      /* モデル情報（例: model : Takito 88cm size1 / grey：senri 134cm size4） */
      if (/^(model|モデル)\s*[:：]/i.test(t) || /\b\d{2,3}\s*cm\s*size\s*\d/i.test(t)) {
        if (!OOJU_KEEP_MODEL_LINE) p.classList.add('ooju-hidden');
        return;
      }
      /* テキストで書かれた「size : 1 , 2 , 3 , 4」 */
      if (/^size\s*[:：]\s*[0-9０-９]\s*[,，]/i.test(t)) {
        p.classList.add('ooju-hidden');
        return;
      }
      /* カラー一覧のテキスト（スウォッチで表現済みのため重複） */
      if (/^color\s*[:：]/i.test(t)) {
        p.classList.add('ooju-hidden');
        return;
      }
      /* 素材はスペック欄へ移動 */
      if (/^(material|素材)\s*[:：]/i.test(t)) {
        material = t.replace(/^(material|素材)\s*[:：]\s*/i, '');
        p.classList.add('ooju-hidden');
      }
    });

    /* --- ⑥ サイズ表を横スクロール対応にし、スペック欄へ移動 --- */
    var table = desc.querySelector('table');
    var tableWrap = null;
    if (table) {
      tableWrap = document.createElement('div');
      tableWrap.className = 'ooju-table-scroll';
      table.parentNode.insertBefore(tableWrap, table);
      tableWrap.appendChild(table);
    }

    /* --- ① サイズ表から身長の目安を読み取って注釈を作る --- */
    var sizeMap = [];
    if (table) {
      var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
      var headCells = rows.length ? Array.prototype.slice.call(rows[0].querySelectorAll('td, th')) : [];
      var heightRow = rows.filter(function (r) {
        var c = r.querySelector('td, th');
        return c && /身長/.test(txt(c));
      })[0];
      if (heightRow && headCells.length) {
        var hCells = Array.prototype.slice.call(heightRow.querySelectorAll('td, th'));
        for (var i = 1; i < headCells.length; i++) {
          var sizeLabel = txt(headCells[i]);
          var h = hCells[i] ? txt(hCells[i]) : '';
          if (sizeLabel && h) sizeMap.push({ size: sizeLabel, height: h });
        }
      }
    }

    /* --- サイズ選択の下に注釈を差し込む ---
       サイズを選ぶとShopifyがバリエーション選択部分を再描画して注釈が消えるため、
       サイズ対応表を保持しておき、消えていたら何度でも復元する。 */
    OOJU_SIZE_MAP = sizeMap;
    renderSizeNote();

    /* --- ⑦ サイズ表・素材をアコーディオンに整理 --- */
    var spec = document.createElement('div');
    spec.className = 'ooju-spec';

    function addItem(id, title, contentNode, open) {
      var item = document.createElement('div');
      item.className = 'ooju-spec__item' + (open ? ' is-open' : '');
      if (id) item.id = id;
      var head = document.createElement('button');
      head.type = 'button';
      head.className = 'ooju-spec__head';
      head.textContent = title;
      var body = document.createElement('div');
      body.className = 'ooju-spec__body';
      body.appendChild(contentNode);
      head.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
      item.appendChild(head);
      item.appendChild(body);
      spec.appendChild(item);
    }

    if (tableWrap) {
      var holder = document.createElement('div');
      holder.appendChild(tableWrap);
      var unit = document.createElement('p');
      unit.className = 'ooju-table-unit';
      unit.textContent = '単位：cm ／ 測り方により多少の誤差が生じる場合があります。';
      holder.appendChild(unit);
      addItem('ooju-size-table', 'サイズ表', holder, true);
    }

    if (material) {
      var m = document.createElement('div');
      m.textContent = material;
      addItem('', '素材', m, false);
    }

    if (spec.children.length) desc.appendChild(spec);
  }

  /* ------------------------------------------------------
     起動
     ------------------------------------------------------ */
  function boot() {
    initCardSwatches(document);
    initProductPage();
    initLowStock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* 一覧の絞り込み・ページ送りで差し替わったカードにも適用 */
  document.addEventListener('shopify:section:load', boot);

  /* バリエーション選択で再描画されたら、サイズ注釈を復元する */
  var mo = new MutationObserver(function () {
    initCardSwatches(document);
    renderSizeNote();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /* テーマがバリエーション変更イベントを発火する場合にも対応 */
  ['variant:update', 'variantChange', 'change'].forEach(function (ev) {
    document.addEventListener(
      ev,
      function () {
        setTimeout(renderSizeNote, 0);
      },
      true
    );
  });
})();
